// extracted by mini-css-extract-plugin
module.exports = {"modal":"WelcomeModal_modal__35K4j","content":"WelcomeModal_content__1Dy62","buttonText":"WelcomeModal_buttonText__3VZJD","footer":"WelcomeModal_footer__3WYAh"};